<div class="flex flex-col gap-4">
  <div class="flex items-start gap-4">
    <div class="flex flex-col gap-4 h-full justify-start flex-1 min-w-0">
      <div class="flex items-center gap-4">
        <div class="bg-white rounded-lg">
          <p-button [label]="'Back'"
                    [severity]="'secondary'"
                    [outlined]="true"
                    [icon]="'fa fa-chevron-left'"
                    (onClick)="goBack()"
          ></p-button>
        </div>

        <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">
          {{ 'Travel Allowance Approval for ' + taSubmission()?.taNumber }}
        </div>

        <div class="flex gap-1 items-center">
          @if (travellersLength() > 1) {
            <i class="fa-solid fa-users"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name + ' (+' + (travellersLength() - 1) + ')'}}</div>
          } @else {
            <i class="fa-solid fa-user"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name}}</div>
          }
        </div>
      </div>
      <div class="justify-start text-text-color text-sm font-semibold font-['Inter'] leading-4">{{'Travel Date: ' + ((taSubmission()?.startDate | date: 'dd/MM/yy') ?? '-') }}</div>

      @if (taSubmission()?.status === 'PendingApproval') {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">This TA is pending approval.</div>

        <ta-approvals-table [taSubmission]="taSubmission()" [editable]="true"></ta-approvals-table>
      }
    </div>

    @if (!taSubmissionDatasource.isFlightOnly()) {
      <div class="flex flex-col gap-2 items-end">
        <ta-cost-bubble title="Total TA Value" [value]="currentTaValue()" severity="outlined"></ta-cost-bubble>
        <div class="w-full h-[1px] bg-surface-200"></div>
        @if (isPrePaid()) {
          <ta-cost-bubble title="Prepayment Component" titleIcon="fa-regular fa-piggy-bank text-green-700" [value]="prepaymentComponent()" severity="success"></ta-cost-bubble>
        }
        <ta-cost-bubble title="Day Trip Component" [value]="dayTripComponent()" severity="purple"></ta-cost-bubble>
      </div>
    }

  </div>


  @if (approvalRole() === 'viewOnly') {
  } @else {
    @if (priorActionedApproval()) {
      <div class="w-full lg:w-1/2 text-text-color text-sm font-normal font-['Inter'] leading-4">
        @if (isGroupApproval()) {
          This TA has already been approved by a member of the <span class="font-semibold">{{ priorActionedApproval()?.displayName }}</span> group.
        } @else if (showApprovalActions()) {
          You have already actioned an approval on this TA &ndash; the approvals still outstanding are listed above.
        } @else {
          You have already approved this TA.
        }
      </div>
    }
    <!-- Approvals are sequential - an approver whose turn has not yet come sees a note instead
         of the action buttons. Finance and System Admins always keep the actions. -->
    @if (pendingApprovalForUser() && !showApprovalActions()) {
      <div class="w-full lg:w-1/2 text-text-color text-sm font-normal font-['Inter'] leading-4">
        This TA is awaiting <span class="font-semibold">{{ currentApproval()?.stageLabel }}</span> approval.
      </div>
    }
    <!-- Finance and System Admins keep the actions even after actioning a slot of their own -
         the note above is context, not a block. -->
    @if (showApprovalActions()) {
      @if (approvalRole() === 'secondaryApprover') {
        <div class="w-full lg:w-1/2 text-text-color text-sm font-normal font-['Inter'] leading-4">
          This TA has been raised by an employee from <span class="font-semibold"><i>another Business Unit</i> </span>. They have selected a project that is owned and funded by your Business Unit.
        </div>
      }

      <div class=" w-full lg:w-1/2 justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">
        <span>{{'Please review the travel allowance details below and select one of the following actions' + ((travellersLength() > 1) ? '.\n' : ':')}}</span>
        @if (travellersLength() > 1) {
          <span>{{'Please note that you are approving travel for a '}}<b>group of staff. </b></span>
        }
      </div>

      <div class="flex gap-10 pt-4">
        <div class="flex flex-col gap-4">
          @if (approvalRole() === 'primaryApprover') {
            <p-button [severity]="'primary'" styleClass="w-64" (onClick)="confirmApproved('approve')">
              <i class="pi pi-check-circle pl-[1px]"></i>
              <span class="flex-1">Approve Travel Allowance</span>
            </p-button>
            <div class="bg-white rounded-lg">
              <p-button [severity]="'secondary'" outlined styleClass="w-64" (onClick)="confirmApproved('withhold')">
                <i class="pi pi-exclamation-circle pl-[1px] text-surface-700"></i>
                <span class="flex-1">Withhold TA Approval</span>
              </p-button>
            </div>
            <p-button [severity]="'danger'" styleClass="w-64" (onClick)="confirmApproved('reject')">
              <i class="pi pi-thumbs-down pl-[1px]"></i>
              <span class="flex-1">Reject Travel Allowance</span>
            </p-button>
          } @else if (approvalRole() === 'secondaryApprover') {
            <p-button [severity]="'primary'" styleClass="w-64" (onClick)="confirmApproved('approve')">
              <i class="pi pi-check-circle pl-[1px]"></i>
              <span class="flex-1">Approve Travel Funding</span>
            </p-button>
            <div class="bg-white rounded-lg">
              <p-button [severity]="'secondary'" outlined styleClass="w-64" (onClick)="confirmApproved('withhold')">
                <i class="pi pi-exclamation-circle pl-[1px] text-surface-700"></i>
                <span class="flex-1">Withhold TA Funding</span>
              </p-button>
            </div>
          }
        </div>
        <div class="h-min-full w-[1px] bg-surface-200"></div>
        <div class="flex flex-col gap-2 flex-1">
          @if (approvalRole() === 'primaryApprover') {
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">If approval is withheld and changes are required, please add comments below:</div>
          } @else if (approvalRole() === 'secondaryApprover') {
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">If funding approval is withheld and changes are required, please add comments below:</div>
          }
          <textarea pTextarea [(ngModel)]="approvalNotes"
                    [placeholder]="approvalRole() === 'primaryApprover'
                    ? 'Click here to add comments explaining why the TA cannot be approved. The TA creator will receive your feedback.'
                    : 'Click here to add comments explaining why the TA funding cannot be approved. The TA creator will receive your feedback.'"
                    rows="4"
                    pSize="small"
                    [autoResize]="true"
                    class="lg:w-2/3 w-full"
          ></textarea>
        </div>
      </div>
    }
  }
</div>
